// extracted by mini-css-extract-plugin
export default {"top":"style_top__m1UII","word":"style_word__BYUAd","delete":"style_delete__vQjcY","flex":"style_flex__lhd5p"};